import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ViewState {
  view: string;
  id?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private readonly currentViewSubject = new BehaviorSubject<ViewState>({view: ''});

  currentView$ = this.currentViewSubject.asObservable();

  navigateTo(view: string, id?: string) {
    this.currentViewSubject.next({ view, id});
  }

  get currentView(): ViewState {
    return this.currentViewSubject.getValue();
  }
}
